import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { API_CTX } from '@/config';
import { queryClient } from '@/lib/react-query';
import { restoreURL } from '@/lib/axios';
import { filterOutFalsyValues } from '@/lib';

import { ItemBase } from '@/types';

const addItem = async ({ payload }: { payload: ItemBase }) => {
  const data = filterOutFalsyValues(payload) as ItemBase;
  await restoreURL().post(`${API_CTX}/items`, data);
};

export const useAddItem = ({ onSuccess }: { onSuccess?: () => void }) => {
  return useMutation<void, Error, { payload: ItemBase }>(
    ({ payload }) => addItem({ payload }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['items']);
        toast.success(`The item has been added successfully`);

        if (onSuccess) {
          onSuccess();
        }
      },
      onError: (error: Error) => {
        toast.error(`An error occurs: ${error.message}`);
      },
    }
  );
};
